import styled from 'styled-components';
import { Card } from 'antd';

export const OptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
`;

export const StyledCard = styled(Card)`
  margin-bottom: 8px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  }
`;

export const FormSectionTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;

  .icon {
    color: #1890ff;
    font-size: 18px;
  }
`;

export const InstructionBox = styled.div`
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 16px;
  display: flex;
  gap: 12px;
  align-items: flex-start;

  .icon {
    color: #0050b3;
    flex-shrink: 0;
    font-size: 16px;
    margin-top: 2px;
  }

  .text {
    color: #0050b3;
    font-size: 13px;
    line-height: 1.5;
    margin: 0;
  }
`;

export const OdontogramContainer = styled.div`
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
`;

export const ConditionsContainer = styled.div`
  background: #fafafa;
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 0;
  border: 1px solid #f0f0f0;

  .conditions-title {
    font-size: 14px;
    font-weight: 600;
    color: #262626;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 8px;

    .icon {
      color: #1890ff;
    }
  }

  .conditions-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
`;

export const TableContainer = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

  .ant-table {
    border-radius: 8px 8px 0 0;
  }

  .ant-table-title {
    padding: 16px;
    border-bottom: 1px solid #f0f0f0;
  }
`;

export const SummaryBox = styled.div`
  background: #fafafa;
  border-left: 4px solid #1890ff;
  padding: 10px 14px;
  border-radius: 4px;
  margin-top: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

  .summary-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }

    .label {
      font-size: 13px;
      font-weight: 500;
      color: #595959;
    }

    .value {
      font-size: 14px;
      font-weight: 600;
      color: #262626;
    }
  }

  .total-final {
    font-size: 15px;
    font-weight: 700;
    margin-top: 6px;
    padding-top: 6px;
    border-top: 2px solid #d9d9d9;
    color: #1890ff;
  }
`;

export const InfoAlert = styled.div`
  background-color: #fffbe6;
  border: 1px solid #ffc069;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 16px;
  display: flex;
  gap: 12px;
  align-items: flex-start;

  .icon {
    color: #ad6800;
    flex-shrink: 0;
    font-size: 16px;
    margin-top: 2px;
  }

  .text {
    color: #ad6800;
    font-size: 13px;
    line-height: 1.5;
    margin: 0;
  }
`;

export const EmptyStateBox = styled.div`
  background: #fafafa;
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  padding: 16px 12px;
  text-align: center;
  color: #8c8c8c;

  .icon {
    font-size: 28px;
    margin-bottom: 6px;
  }

  .text {
    font-size: 13px;
    margin-bottom: 6px;
  }

  button {
    margin-top: 12px;
  }
`;

export const HeaderWrapper = styled.div`
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 2px solid #f0f0f0;
`;

export const SectionWrapper = styled.div`
  margin-bottom: 12px;
`;

export const OdontogramWrapper = styled.div`
  .odontogram-title {
    font-size: 14px;
    font-weight: 600;
    color: #262626;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 8px;

    .icon {
      color: #1890ff;
    }
  }
`;
